import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_components");

Vue.use(Router);

const routes = [{
        path: "/",
        component: _import("www/main"),
        children: [{
            path: "/",
            name: "index",
            component: _import("www/index"),
        }],
    },

    {
        path: "/israel",
        component: _import("israel/index"),
        children: [{
                path: "/",
                component: _import("israel/compete-Pre"),
            },
            {
                path: "/israel/login",
                component: _import("israel/login"),
            },
            {
                path: "/israel/userIndex",
                component: _import("israel/userIndex"),
            },
        ],
    },
    {
        path: "/myc2025",
        component: _import("myc2025/main"),
        children: [{
                path: "/myc2025",
                component: _import("myc2025/index"),
            },
        ],
    },

    {
        path: "/aimsity",
        component: _import("aimsity/main"),
        children: [{
                path: "/aimsity",
                component: _import("aimsity/index"),
            },
            {
                path: "/aimsity/comming",
                component: _import("aimsity/comming"),
            },
            {
                path: "/aimsity/pay",
                component: _import("aimsity/pay"),
            },
        ],
    },

    {
        path: "/mgtv",
        component: _import("mgtv/main"),
        children: [{
                path: "/mgtv",
                name: "mgtv",
                component: _import("mgtv/index"),
            },
        ],
    },
    {
        path: "/mgtv_semi",
        component: _import("mgtv/main"),
        children: [{
                path: "/mgtv_semi",
                name: "mgtv_semi",
                component: _import("mgtv/index"),
            },
        ],
    },
    {
        path: "/mgtv_final",
        component: _import("mgtv/main"),
        children: [{
                path: "/mgtv_final",
                name: "mgtv_final",
                component: _import("mgtv/index"),
            },
        ],
    },
    {
        path: "/wrc_singapore",
        component: _import("wrc_singapore/main"),
        children: [{
                path: "/wrc_singapore",
                component: _import("wrc_singapore/index"),
            },
        ],
    },
    {
        path: "/wrc_malaysia",
        component: _import("wrc_malaysia/main"),
        children: [{
                path: "/wrc_malaysia",
                component: _import("wrc_malaysia/index"),
            },
        ],
    },
    {
        path: "/vn",
        component: _import("vn/index"),
    },
];


function addCRouter(channel, dir){
    if(dir == undefined) dir = channel;

    routes.push({
        path: `/${channel}`,
        component: _import(`${dir}/index`),
        children: [{
                path: "/",
                name: channel + "#index",
                component: _import(`${dir}/compete-Pre`),
            },
            {
                path: `/${channel}/login`,
                name: channel + "#login",
                component: _import(`${dir}/login`),
            },
            {
                path: `/${channel}/signup`,
                name: channel + "#signup",
                component: _import(`${dir}/signup`),
            },
            {
                path: `/${channel}/userIndex`,
                name: channel + "#userIndex",
                component: _import(`${dir}/userIndex`),
            },
            {
                path: `/${channel}/rank`,
                component: _import(`${dir}/rank`),
            },
            {
                path: `/${channel}/userGroups`,
                component: _import(`${dir}/user-groups`),
            },
        ],
    })
}

// addCRouter("demo", "demo_0_v2"); // 基准模版

// 全国
addCRouter("teacher"); // 教师培训及考核

addCRouter("2025", "2025_global");  // 第六届ICode国际青少年编程活动
// addCRouter("2025", "2025");  // 第七届ICode国际青少年编程活动
// addCRouter("2025", "2025_final");  // 第七届ICode国际青少年编程活动中国区决赛

//wrc
// addCRouter("wrc_learn"); // 24年wrc训练平台
// wrc无需增加新的router

// 四川
addCRouter("SCSSN2024"); // “新时代·蜀少年”2024年四川省青少年文化艺术展演（科技创新类）


// WRC相关活动
routes.push({
    path: "/wrc",
    component: _import("wrc/index"),
    children: [{
        name: "wrc_list",
        path: "/",
        component: _import("wrc/compete-Pre"),
    }],
})

routes.push({
    path: "/wrc_:channel",
    name: "wrc_main",
    component: _import("wrc/template/main"),
    children: [{
            name: "wrc_index",
            path: "/wrc_:channel/",
            component: _import("wrc/template/index"),
        },
        {
            name: "wrc_login",
            path: "/wrc_:channel/login",
            component: _import("wrc/template/login"),
        },
        {
            name: "wrc_signup",
            path: `/wrc_:channel/signup`,
            component: _import("wrc/template/signup"),
        },
        {
            name: "wrc_userIndex",
            path: `/wrc_:channel/userIndex`,
            component: _import("wrc/template/userIndex"),
        },

    ],
})

// WRC相关活动
routes.push({
    path: "/cngef",
    component: _import("cngef/main"),
    children: [{
        name: "cngef_list",
        path: "/",
        component: _import("cngef/index"),
    }],
})

routes.push({
    path: "/cngef_:channel",
    name: "cngef_main",
    component: _import("cngef/template/main"),
    children: [{
            name: "cngef_index",
            path: "/cngef_:channel/",
            component: _import("cngef/template/index"),
        },
        {
            name: "cngef_login",
            path: "/cngef_:channel/login",
            component: _import("cngef/template/login"),
        },
        {
            name: "cngef_signup",
            path: `/cngef_:channel/signup`,
            component: _import("cngef/template/signup"),
        },
        {
            name: "cngef_userIndex",
            path: `/cngef_:channel/userIndex`,
            component: _import("cngef/template/userIndex"),
        },

    ],
})

routes.push({
    path: "/:channel",
    name: "contest_main",
    component: _import("template/main"),
    children: [{
            name: "contest_index",
            path: "/:channel/",
            component: _import("template/index"),
        },
        {
            name: "contest_login",
            path: "/:channel/login",
            component: _import("template/login"),
        },
        {
            name: "contest_signup",
            path: `/:channel/signup`,
            component: _import("template/signup"),
        },
        {
            name: "contest_userIndex",
            path: `/:channel/userIndex`,
            component: _import("template/userIndex"),
        },

    ],
})

// 加到最后面；
routes.push(
    {
        path: "/404",
        name: "t404",
        component: () =>
            import ("../components/common/t404.vue"),
    },
)

routes.push(
    {
        path: "*",
        redirect: "/404",
    },
)


const router = new Router({
    //后端支持可开
    mode: "history",
    routes: routes,

    scrollBehavior: () => ({
        y: 0,
    }),
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js